module.exports = __webpack_public_path__ + "img/9969a9d.svg";